import { setCookie, destroyCookie, getCookie } from 'utils/cookies';

import SETTINGS from '../settings';

const AuthCookie = {
  get: (ctx = null) => {
    if (ctx?.query?.access_token) {
      const value = ctx.query.access_token;
      AuthCookie.set(`_debug_${value}`, ctx);
      return { value, debug: true };
    }

    const value = getCookie(ctx, SETTINGS.COOKIE_ACCESS_TOKEN_NAME);
    if (value != null) {
      if (value.indexOf('_debug_') === 0) {
        return { value: value.replace('_debug_', ''), debug: true };
      }
    }

    return { value, debug: false };
  },

  set: (accessToken, ctx = null) => {
    setCookie(
      ctx,
      SETTINGS.COOKIE_ACCESS_TOKEN_NAME,
      accessToken,
      SETTINGS.COOKIE_ACCESS_TOKEN_OPTIONS,
    );
  },

  destroy: (ctx = null) => {
    destroyCookie(ctx, SETTINGS.COOKIE_ACCESS_TOKEN_NAME, SETTINGS.COOKIE_ACCESS_TOKEN_OPTIONS);
  },
};

export default AuthCookie;
